import styled from "styled-components"

export const FooterStyles = styled.footer`
  &.section {
    margin-top: var(--sectionMargin);
    margin-bottom: 0;
    padding-top: var(--gap);
    padding-bottom: var(--gap);
    border-top: 1px solid var(--color-line);
  }

  .footer__top {
    display: flex;
    flex-direction: column;
    gap: var(--gap);
    justify-content: space-between;

    @media (min-width: 768px) {
      flex-direction: row;
      align-items: flex-start;
    }
  }

  .footer__cta {
    font-family: var(--font-display);
    font-weight: 700;
    font-size: var(--text-title);
    line-height: 1.05;
    letter-spacing: -0.01em;
    color: var(--color-paper);
    margin: 1.4rem 0 1.6rem;

    .accent {
      color: var(--color-gold-500);
    }
  }

  .footer__email {
    display: inline-block;
    font-family: var(--font-sans);
    font-size: 0.85rem;
    letter-spacing: 0.04em;
    color: var(--color-ash);
    text-decoration: none;
    border-bottom: 1px solid var(--color-line);
    padding-bottom: 3px;
    transition: color 0.3s var(--ease-power),
      border-color 0.3s var(--ease-power);

    &:hover {
      color: var(--color-gold-500);
      border-color: var(--color-gold-500);
    }
  }

  .footer__nav {
    .footer__navlabel {
      font-family: var(--font-sans);
      font-size: var(--text-kicker);
      letter-spacing: 0.3em;
      text-transform: uppercase;
      color: var(--color-faint);
      margin: 0 0 1.2rem;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      gap: 0.65rem;
    }

    li a {
      color: var(--color-ash);
      text-decoration: none;
      text-transform: capitalize;
      font-weight: 500;
      transition: color 0.3s var(--ease-power);

      &:hover {
        color: var(--color-gold-500);
      }
    }
  }

  .rule {
    margin: calc(var(--gap) * 1.2) 0 var(--gap);
  }

  .footer__bottom {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
    justify-content: space-between;

    @media (min-width: 768px) {
      flex-direction: row;
      align-items: center;
    }

    p {
      margin: 0;
      font-family: var(--font-sans);
      font-size: 12px;
      letter-spacing: 0.04em;
      color: var(--color-faint);
    }
  }
`
